<template>
  <generic-modal
    size="large"
    :title="$t('ecosystem')"
    icon="terminal"
    image="/images/icons/pm2.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    :show_ok="false"
    :footer_buttons="footer_buttons"
  >
    <div class="description">
      <h3 class="ui dividing header">
        {{ $t("ecosystem configuration") }}
      </h3>
      <div class="ui top attached tabular menu" ref="tabs">
        <a class="active item" data-tab="crontab">{{ $t("crontab") }}</a>
        <a class="item" data-tab="pm2">{{ $t("pm2") }}</a>
      </div>
      <div class="ui bottom attached active tab segment" data-tab="crontab">
        <div class="ui relaxed list">
          <div class="item" v-for="(app, appidx) in apps_crontab" :key="appidx">
            <div
              class="ui orange basic mini icon button"
              @click="copy_single_crontab(app)"
            >
              <i class="copy icon"></i>
            </div>
            {{ app | truncate(200) }}
          </div>
        </div>
      </div>
      <div class="ui bottom attached tab segment" data-tab="pm2">
        <pre ref="ecosystem_content">
module.exports = { 
  apps: {{ apps }}
}</pre
        >
      </div>
    </div>
  </generic-modal>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import filters from "@/filters";
import GenericModal from "@/components/GenericModal";
import copy from "copy-to-clipboard";

export default {
  name: "EcosystemModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
  },
  computed: {},
  props: { robots: Array },
  data() {
    return {
      apps: [],
      apps_crontab: [],
      footer_buttons: [
        {
          icon: "copy",
          color: "blue",
          text: this.$t("copy to clipboard"),
          click: this.copy_clipboard,
        },
        {
          icon: "help",
          color: "orange",
          text: this.$t("help"),
          click: this.help,
        },
      ],
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    copy_clipboard() {
      let ecosystem = window.jQuery(this.$refs.ecosystem_content).html();
      copy(ecosystem);
      this.$alertify.success(this.$t("configuration copied to clipboard"));
    },
    help() {
      console.log("show help");
    },
    copy_single_crontab(app) {
      copy(app);
      this.$alertify.success(this.$t("configuration copied to clipboard"));
    },
  },
  beforeMount() {
    let vm = this;
    if (vm.robots) {
      let apps = vm.robots.map((rbt) => {
        return {
          name: rbt.setup.general.name,
          script: rbt.setup.general.absolute_path,
          instances: 1,
          exec_mode: "fork",
          cron_restart: rbt.setup.general.cron,
        };
      });
      vm.apps = apps;

      let apps_crontab = vm.robots.map((rbt) => {
        return `${rbt.setup.general.cron}  node ${rbt.setup.general.absolute_path} >> ${rbt.setup.general.absolute_path}_$(date +%Y%m%d).log`;
      });
      vm.apps_crontab = apps_crontab;
    }
  },
  mounted() {
    let vm = this;

    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();
  },
};
</script>
